var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { QboFetch } from './qbo-fetch.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
/**
  * Renders popup content.
  *
  * @remarks
  * This element is a thin wrapper around {@link QboFetch} that renders a <select> element with options populated from a JSON array.
  */
let QboPopup = class QboPopup extends QboFetch {
    constructor() {
        super(...arguments);
        this.open = false;
        this.loading = false;
        this.renderInHost = false;
    }
    // container: HTMLElement;
    static { this.styles = [
        css `
            /* Add any custom styles here */
            .foo { color: red; }
        `
    ]; }
    async connectedCallback() {
        super.connectedCallback();
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }
    //updated(changedProperties) {
    //    super.updated(changedProperties);
    //    if (this.container != null)
    //        this.container.style.display = (changedProperties.has('show')) ? 'flex' : 'none';
    //}
    toggle() {
        this.open = !this.open;
        if (this.open)
            document.addEventListener('click', this.handleOutsideClick);
        else
            document.removeEventListener('click', this.handleOutsideClick);
    }
    show() {
        //if (this.container == null)
        //    this.container = this.shadowRoot.querySelector('.modal-container')
        //this.container.style.display = 'flex';
        this.open = true;
        document.addEventListener('click', this.handleOutsideClick);
    }
    hide(event) {
        if (event.target.closest('[data-dismiss="modal"]')) {
            // this.togglePopup(false);
            this.open = false;
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }
    handleOutsideClick(event) {
        if (this.open && !this.contains(event.target)) {
            // this.togglePopup(false);
            this.open = false;
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }
    render() {
        return html `
        <slot name="button" @click="${this.toggle}">
            <button class="btn">Popup</button>
        </slot>
        <slot name="content" @click="${this.hide}" style="display:${this.open ? 'flex' : 'none'}">${unsafeHTML(this.html)}</slot>
    `;
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopup.prototype, "open", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopup.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopup.prototype, "renderInHost", void 0);
QboPopup = __decorate([
    customElement('qbo-popup')
], QboPopup);
export { QboPopup };
